"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleGtmValidationError = exports.modifyFormData = exports.performReCaptchaCheck = exports.shouldRenderControl = exports.handleError = exports.updateInitialFormValues = exports.ErrorType = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var SignUpFormConfig_1 = require("Views/Partials/Components/SignUp/SignUpFormConfig");
var Forms_1 = require("Forms");
var ErrorType;
(function (ErrorType) {
    ErrorType["validationError"] = "Front-end validation error";
    ErrorType["serverError"] = "Back-end error";
    ErrorType["countryValidationError"] = "Front-end validation embargo country error";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var updateInitialFormValues = function (props, initialFormState) {
    Object.values(props.inputObject)
        .filter(function (_a) {
        var defaultValue = _a.defaultValue;
        return defaultValue;
    })
        .forEach(function (_a) {
        var name = _a.name, defaultValue = _a.defaultValue;
        initialFormState[String(name)] = defaultValue;
    });
    return initialFormState;
};
exports.updateInitialFormValues = updateInitialFormValues;
var handleError = function (gtmData, renderMessage, specificFields) {
    var errorMessageTitleText = specificFields.errorMessageTitleText, errorMessageText = specificFields.errorMessageText;
    app_1.GTM.newsletter.error(tslib_1.__assign(tslib_1.__assign({}, gtmData), { errorType: ErrorType.serverError }));
    renderMessage(errorMessageTitleText, errorMessageText);
};
exports.handleError = handleError;
var shouldRenderControl = function (formControl, props, formState) {
    if (formControl.key === SignUpFormConfig_1.formControlKeys.language) {
        var languages = props.items.languages;
        if (!shouldRenderLanguage(formState, languages)) {
            return false;
        }
    }
    return true;
};
exports.shouldRenderControl = shouldRenderControl;
var shouldRenderLanguage = function (_a, languages) {
    var country = _a.country;
    return Boolean(country && languages && languages[country]);
};
var performReCaptchaCheck = function (recaptchaRef, renderMessage, specificFields) {
    var captchaEl = recaptchaRef.current;
    var reCaptchaInitialized = captchaEl.getWidgetId() !== null;
    var errorMessageTitleText = specificFields.errorMessageTitleText, errorMessageText = specificFields.errorMessageText;
    if (reCaptchaInitialized) {
        captchaEl.execute();
    }
    else {
        /*
          When recaptcha widget is not initialized due to network issues
          we send form with empty token. This should result with error response from BE.
        */
        renderMessage(errorMessageTitleText, errorMessageText);
    }
};
exports.performReCaptchaCheck = performReCaptchaCheck;
var modifyFormData = function (data, modifiedData) {
    var _a;
    if (modifiedData === void 0) { modifiedData = {}; }
    delete Object.assign(modifiedData, data, (_a = {}, _a['userConsent'] = data['consentCheckbox'], _a))['consentCheckbox'];
    return modifiedData;
};
exports.modifyFormData = modifyFormData;
var handleGtmValidationError = function (isValidating, isSubmitting, gtmData, errors, values) {
    if (isValidating && isSubmitting) {
        Object.keys(errors).forEach(function (field) {
            var errorType = field === 'country' && Forms_1.validateCountry(values.country)
                ? ErrorType.countryValidationError
                : ErrorType.validationError;
            app_1.GTM.newsletter.error(tslib_1.__assign(tslib_1.__assign({}, gtmData), { errorType: errorType, errorField: field }));
        });
    }
};
exports.handleGtmValidationError = handleGtmValidationError;
